import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import CelularesPdsvForm from './celulares-pdvs-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import {error, success, warning} from '../../../../utils/notification-actions';
import {connect} from 'react-redux';
import {getFileName} from '../../../../utils/utils';
import * as moment from 'moment';

class CelularesPdvs extends React.PureComponent<ReduxProps> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    public async handleGenerarExcel(values) {
        const filtro = values.filtro ? values.filtro.value : null;
        let periodo = values.periodo ? values.periodo.value : null;
        let fecha = moment(values.fecha).format('DD/MM/YYYY');
        if(filtro === 'periodo'){
            fecha = '';
        }else if(filtro === 'fecha'){
            periodo = '';
        }
        try {
            this.props.dispatch(warning('Notificación', 'El reporte esta siendo generado, por favor espere y no refresque la página'));
            const prioritariosResponse = await this.apiClient.descargarCelularesPdvs(periodo, fecha);
            fileDownload(prioritariosResponse.data, getFileName(prioritariosResponse));
            this.props.dispatch(success('Notificación', 'Excel generado correctamente'));
        } catch (ex) {
            this.props.dispatch(error('Error', 'No se encontró información para la fecha seleccionada'));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Celulares: Avance x PDV</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <CelularesPdsvForm onSubmit={this.handleGenerarExcel}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(CelularesPdvs);



// WEBPACK FOOTER //
// ./src/components/pages/celulares/zonas/celulares-pdvs.tsx